import React, { useEffect, useState } from "react";
import { loseSoundBingo } from "utils/config/reference";
import { useAudio } from "utils/context/AudioProvider";
import {captureException}from '@sentry/react';
import { useHowlAudio } from "components/hooks/useHowlProvider";
import loteriaWinGif1 from "../../../utils/assets/images/Lotería_win_gif1.gif";
import loteriaWinGif2 from "../../../utils/assets/images/Lotería_win_gif2.gif";
import loteriaWinGif3 from "../../../utils/assets/images/Lotería_win_gif3.gif";
import loteriaWinGif4 from "../../../utils/assets/images/Lotería_win_gif4.gif";
import loteriaWinGif5 from "../../../utils/assets/images/Lotería_win_gif5.gif";
import loteriaWinGif6 from "../../../utils/assets/images/Lotería_win_gif6.gif";
import loteriaWinGif7 from "../../../utils/assets/images/Lotería_win_gif7.gif";
import loteriaWinGif8 from "../../../utils/assets/images/Lotería_win_gif8.gif";

const BingoLoseScreen = () => {
  const gifs = [
    loteriaWinGif1,
    loteriaWinGif2,
    loteriaWinGif3,
    loteriaWinGif4,
    loteriaWinGif5,
    loteriaWinGif6,
    loteriaWinGif7,
    loteriaWinGif8,
  ];

  const [randomGif, setRandomGif] = useState(null);
  const { stopAudio,playAudio } = useAudio();
  const { playHowl, cleanupHowl } = useHowlAudio();

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * gifs.length);
    setRandomGif(gifs[randomIndex]);
     const audioConfig = {
      src: [loseSoundBingo],
      volume: 0.7,
      html5: true,
      loop: true,
      onError: (error) => {
        captureException(`624 Error in playSound: ${error}`);
        console.error("Error playing audio:", error);
      }
    };

    playHowl(audioConfig, 'bingoLoseSound');

    return () => {
      cleanupHowl('bingoLoseSound'); // This stops, unloads, and removes the instance
      stopAudio();
    };
  }, []);

  return (
    <div>
      <div className="loteria-card-lose">
        <div className="loteria-content">
          <h2>
            No ganaste,
            <br />
            try again...
          </h2>
        </div>
      </div>
      <div className="loteria-animation-lose">
        <img src={randomGif} alt="loteria-animation" />
      </div>
    </div>
  );
};

export default BingoLoseScreen;
